import { isEmpty } from 'lodash';
import { EMPTY_DRAFT_FIELD } from '../../Form/DraftEditorField/constants';

export const isEligTextEmpty = eligibility_text => isEmpty(eligibility_text) || eligibility_text === EMPTY_DRAFT_FIELD;
